/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  BeginBindingRefreshRequestBody,
  BeginBindingRefreshRequestBody$Outbound,
  BeginBindingRefreshRequestBody$outboundSchema,
} from "../components/beginbindingrefreshrequestbody.js";

export type BeginBindingRefreshSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type BeginBindingRefreshRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  beginBindingRefreshRequestBody: BeginBindingRefreshRequestBody;
};

/** @internal */
export type BeginBindingRefreshSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const BeginBindingRefreshSecurity$outboundSchema: z.ZodMiniType<
  BeginBindingRefreshSecurity$Outbound,
  BeginBindingRefreshSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function beginBindingRefreshSecurityToJSON(
  beginBindingRefreshSecurity: BeginBindingRefreshSecurity,
): string {
  return JSON.stringify(
    BeginBindingRefreshSecurity$outboundSchema.parse(
      beginBindingRefreshSecurity,
    ),
  );
}

/** @internal */
export type BeginBindingRefreshRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  BeginBindingRefreshRequestBody: BeginBindingRefreshRequestBody$Outbound;
};

/** @internal */
export const BeginBindingRefreshRequest$outboundSchema: z.ZodMiniType<
  BeginBindingRefreshRequest$Outbound,
  BeginBindingRefreshRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    beginBindingRefreshRequestBody:
      BeginBindingRefreshRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      beginBindingRefreshRequestBody: "BeginBindingRefreshRequestBody",
    });
  }),
);

export function beginBindingRefreshRequestToJSON(
  beginBindingRefreshRequest: BeginBindingRefreshRequest,
): string {
  return JSON.stringify(
    BeginBindingRefreshRequest$outboundSchema.parse(beginBindingRefreshRequest),
  );
}
